import clsx from 'clsx';
import styles from './status-pill.module.scss';

type StatusPillProps = {
  daysUntilDue: number | undefined;
  status: string;
};

export const StatusPill = ({ daysUntilDue, status }: StatusPillProps) => {
  return (
    <span
      className={clsx(
        styles.statusPills,
        daysUntilDue !== undefined && getStatusClassName(daysUntilDue)
      )}
    >
      {status}
    </span>
  );
};

const getStatusClassName = (daysUntilDue: number) => {
  if (daysUntilDue < 0) {
    return styles.lateStatusPill;
  }
  if (daysUntilDue <= 7) {
    return styles.dueIn7DaysOrLessPill;
  }
  if (daysUntilDue <= 30) {
    return styles.dueIn30DaysOrLessPill;
  }
  return styles.dueIn31DaysOrMorePill;
};
